import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
import { DateUtil } from "../utils/DateUtil";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class PeriodSchedule {
    _startDate;
    jsStartDate;
    _endDate;
    jsEndDate;
    _type = "custom";
    constructor(params) {
        this.startDate = params.startDate;
        this.endDate = params.endDate;
        if (params.type) {
            this.type = params.type;
        }
        this.updateJsValues();
    }
    updateJsValues() {
        this.jsStartDate = DateUtil.normalizeDateToJsDate(this.startDate);
        this.jsEndDate = DateUtil.normalizeDateToJsDate(this.endDate);
    }
    updateModelValues() {
        this.startDate = DateUtil.normalizeDate(this.jsStartDate);
        this.endDate = DateUtil.normalizeDate(this.jsEndDate);
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get startDate() {
        return this._startDate;
    }
    set startDate(value) {
        this._startDate = DateUtil.normalizeDate(value);
    }
    get endDate() {
        return this._endDate;
    }
    set endDate(value) {
        this._endDate = DateUtil.normalizeDate(value);
    }
    get json() {
        this.updateJsValues();
        return {
            startDate: this.jsStartDate,
            endDate: this.jsEndDate,
            type: this.type,
        };
    }
    toJSON() {
        return this.json;
    }
}
